<template>
  <div style="height: 600px;">
    <!-- <ul class="menu">
      <li v-for="(item, index) in picList.slice(0,3)" :key="index" class="menu-cell" @click="goMarker(item.full_name)">
        <img class="menu-cell__image" :src="item.url">
        <div class="menu-cell__title">{{ item.name }}</div>
      </li>
      <li class="menu__placeholder"></li>
      <li v-for="(item, index) in picList.slice(3,4)" :key="index+3" class="menu-cell" @click="goMarker(item.full_name)">
        <img class="menu-cell__image" :src="item.url">
        <div class="menu-cell__title">{{ item.name }}</div>
      </li>
      <li class="menu__half-placeholder"></li>
      <li v-for="(item, index) in picList.slice(4,8)" :key="index+4" class="menu-cell" @click="goMarker(item.full_name)">
        <img class="menu-cell__image" :src="item.url">
        <div class="menu-cell__title">{{ item.name }}</div>
      </li>
      <li class="menu__half-placeholder"></li>
      <li v-for="(item, index) in picList.slice(8,13)" :key="index+8" class="menu-cell" @click="goMarker(item.full_name)">
        <img class="menu-cell__image" :src="item.url">
        <div class="menu-cell__title">{{ item.name }}</div>
      </li>
      <li class="menu__half-placeholder"></li>
      <li v-for="(item, index) in picList.slice(13,17)" :key="index+8" class="menu-cell" @click="goMarker(item.full_name)">
        <img class="menu-cell__image" :src="item.url">
        <div class="menu-cell__title">{{ item.name }}</div>
      </li>
      <li class="menu__half-placeholder"></li>
    </ul> -->
    <ul class="menu">
      
      <li v-for="(item, index) in picList.slice(0,6)" :key="index" class="menu-cell" @click="goMarker(item.full_name)">
        <img class="menu-cell__image" :src="item.url">
        <div class="menu-cell__title">{{ item.name }}</div>
      </li>
      <li class="menu__half-placeholder"></li>
      <li v-for="(item, index) in picList.slice(6,11)" :key="index+6" class="menu-cell" @click="goMarker(item.full_name)">
        <img class="menu-cell__image" :src="item.url">
        <div class="menu-cell__title">{{ item.name }}</div>
      </li>
      <li class="menu__half-placeholder"></li>
      <li v-for="(item, index) in picList.slice(11,17)" :key="index+11" class="menu-cell" @click="goMarker(item.full_name)">
        <img class="menu-cell__image" :src="item.url">
        <div class="menu-cell__title">{{ item.name }}</div>
      </li>
      
    </ul>
  </div>
</template>
 
<script>
import homePic from '@/assets/json/home/home_picture.json'

export default {
  data () {
    return {
      picList: homePic
    }
  },
  mounted () {
  },
  watch: {
  },
  created () {
  },
  methods: {
    goMarker(spe) {
      this.$router.push('/marker?species='+spe)
    }
  }
}
</script>
 
<style scoped>
  *, *::before, *::after {
    box-sizing: border-box;
  }
  .menu {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: center;
    align-items: center;
    width: 1200px; /*980*/
    margin: 0 auto;
    padding: 0;
    -webkit-transform: translateY(16.25px); /*34.375px*/
    transform: translateY(16.25px);
  }
  .menu-cell {
    flex: 0 1 180px; /*150*/
    max-width: 180px; /*150*/
    height: 106.2px; /*88.5*/
    margin: 36px 6.6px 30px; /*30px 5.5px 25px*/
    position: relative;
    padding: 0.5em;
    text-align: center;
    background: #f7fcfd;
    cursor: pointer;
    z-index: 1;
  }
  .menu-cell::before {
    background: #e5f5f9;
    -webkit-transform: scale(1.055);
    transform: scale(1.055);
  }
  .menu-cell::after {
    background: #f7fcfd;
    opacity: 0.5;
    transition: opacity 350ms;
  }
  .menu-cell::before, .menu-cell::after {
    content: '';
  }
  .menu-cell:hover::before {
    background: #ccece6;
    -webkit-transform: scale(1.055);
    transform: scale(1.055);
  }
  .menu-cell:hover::after {
    opacity: 0.2;
    transition: opacity 350ms;
  }
  .menu__placeholder {
    opacity: 0;
    width: 180px;
    margin: 0 6.6px;
  }
  .menu__half-placeholder {
    opacity: 0;
    width: 90px;
    margin: 0 6.6px;
  }
  .menu-cell__image {
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;
    border-style: none;
  }
  .menu-cell__image{
    width: 120px;
    height: 120px;
    margin-top: -13px;
    transition: all 350ms ease;
  }
  .menu-cell__image:hover{
    width: 125px;
    height: 125px;
    margin-top: -18px;
  }
  .menu-cell__title {
    height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    word-break: break-word;
    /* text-transform: uppercase; */
    color: #333;
    font-weight: 700;
    font-size: .75em;
    transition: opacity 350ms;
  }
  .menu-cell::before, .menu-cell::after{
    top: -50%;
    left: 0;
    width: 100%;
    height: 200%;
    display: block;
    position: absolute;
    -webkit-clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    z-index: -1;
  }
</style>